if (typeof window.modalAddons === "undefined") {
  window.modalAddons = async () => {
    let mainProductSubscriptionSelection = null;
    const MODULE_NAME = 'Modal Addons'
    const MODAL_ADDONS_IDENTIFIER = "#modal-addons";
    const MODAL_EDIT_BUILD_A_BOX_IDENTIFIER = "#modal-edit-build-a-box";

    const printLog = (message) => {
      console.log(
        `%c${MODULE_NAME}`, // Module Name
        'font-weight: bold; color: #000; background: #f2e8d0; border-radius: 3px; padding-left: 5px; padding-right: 5px;',
        message,
      );
    }

    const validateRequiredScripts = async (timeout = 5000) => {
      const start = Date.now();

      while (true) {
        const hasJQuery = typeof window.jQuery === "function";
        const hasStockmanSteaks = typeof window.stockmansteaks !== "undefined";

        if (hasJQuery && hasStockmanSteaks) {
          break;
        }

        if (Date.now() - start >= timeout) {
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 50)); // wait 50ms before rechecking
      }
    };

    const setup = () => {
      if ($(MODAL_ADDONS_IDENTIFIER).length <= 0) {
        printLog(`⚠️ ${MODAL_ADDONS_IDENTIFIER} not found`);
        return;
      }

      // Intercept the fetch method
      var originalFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];

        if (url === "/cart/add") {
          return originalFetch.apply(this, arguments).then((response) => {
            toggleModal($(MODAL_ADDONS_IDENTIFIER), true);
            return response;
          });
        }

        return originalFetch.apply(this, arguments);
      };
    };

    const refreshMinusButton = ($el) => {
      const $parent = $el.closest("[data-product-item]");
      const $minus = $parent.find(".modal-addons__product-qty-button__minus");
      const $qtyInput = $parent.find(".modal-addons__product-qty-input");
      const value = Number($qtyInput.val());

      if (value <= 0) {
        $minus.attr("disabled", "disabled");
      } else {
        $minus.removeAttr("disabled");
      }
    };

    const refreshSummary = ($el) => {
      const $modal = $el.closest(".modal-addons");
      const $parent = $el.closest("[data-product-item]");
      const $qtyInput = $parent.find(".modal-addons__product-qty-input");
      const $price = $parent.find(".modal-addons__product-price");
      const title = $parent.find(".modal-addons__product-title").html();
      const price = Number($price.data("value"));
      const qty = Number($qtyInput.val());
      const subtotal = price * qty;
      const variantId = $parent.data("variant-id");
      const $summaryList = $modal.find(".modal-addons__summary-list");
      const $existingSummaryItem = $summaryList.find(
        `[data-summary-variant-id=${variantId}]`
      );

      // Refresh Summary Items
      if ($existingSummaryItem.length > 0) {
        if (qty > 0) {
          // update the new line item
          const $value = $existingSummaryItem.find(
            ".modal-addons__summary-list__value"
          );

          $value.html(`$${subtotal.toFixed(2)}`);
          $value.data("value", subtotal);
        } else {
          // delete
          $existingSummaryItem.remove();
        }
      } else {
        if (qty > 0) {
          // create a new line item
          let $newSummaryItem = $(`
            <li class="modal-addons__summary-list__item" data-summary-item-type="addon" data-summary-variant-id="${variantId}">
              <p class="modal-addons__summary-list__heading">${title}</p>
              <p class="modal-addons__summary-list__value" data-value="${subtotal.toFixed(
                2
              )}">$${subtotal.toFixed(2)}</p>
            </li>
            `);

          $summaryList.append($newSummaryItem);
        } else {
          // do nothing
        }
      }

      // Refresh Summary Totals
      recalculateTotal($modal);
    };

    const getTotal = ($modal) => {
      let total = 0;
      $modal.find(".modal-addons__summary-list__item").each(function () {
        total += Number(
          $(this).find(".modal-addons__summary-list__value").data("value")
        );
      });

      return total;
    };

    const recalculateTotal = ($modal) => {
      const $total = $modal.find(".modal-addons__total");
      const total = getTotal($modal);

      $total.html(`$${total.toFixed(2)}`);

      validateTotal($modal);
    };

    const validateTotal = ($modal) => {
      const total = getTotal($modal);
      const minValueInCents = Number($modal.data("min-value")) ?? 0;
      const validationPassed = total * 100 > minValueInCents;

      // Handle error
      toggleErrorNotification($modal, !validationPassed);

      return validationPassed;
    };

    const setQuantity = ($el, amount) => {
      const $parent = $el.closest("[data-product-item]");
      const $qtyInput = $parent.find(".modal-addons__product-qty-input");

      let value = isNaN(amount) ? 0 : Number(amount);
      if (value < 0) {
        value = 0;
      }

      $qtyInput.val(value);

      // Refresh
      refreshMinusButton($el);
      refreshSummary($el, value);
    };

    const moveQuantity = ($el, amount) => {
      const $parent = $el.closest("[data-product-item]");
      const $qtyInput = $parent.find(".modal-addons__product-qty-input");

      let value = Number($qtyInput.val());
      value += amount;
      if (value < 0) {
        value = 0;
      }

      $qtyInput.val(value);

      // Refresh
      refreshMinusButton($el);
      refreshSummary($el, value);
    };

    const toggleModal = ($modal, value) => {
      const $body = $("body");

      if (value) {
        $modal.fadeIn("fast");
        $body.addClass("modal-addons-active");
      } else {
        $modal.fadeOut("fast");
        $body.removeClass("modal-addons-active");
      }
    };

    const populateBuildABoxItems = ($el) => {
      const $modal = $(MODAL_EDIT_BUILD_A_BOX_IDENTIFIER);
      const $cartItem = $el.closest(".cart-item");
      const $contentItems = $cartItem.find(".build-a-box-content li");
      const $sellingPlan = $cartItem.find("[data-selling-plan-name]");
      const $selectedSellingPlan = $modal.find(
        "[name=selected_selling_plan_name]"
      );
      const $rcBundleIdField = $modal.find("[name=_rc_bundle]");
      const $rcBundleParentField = $modal.find("[name=_rc_bundle_parent]");
      const $rcBundleVariantField = $modal.find("[name=_rc_bundle_variant]");
      const $rcBundleCollectionIdField = $modal.find(
        "[name=_rc_bundle_collection_id]"
      );

      // Set bundle id
      $rcBundleIdField.val(
        $cartItem.find('[data-name="_rc_bundle"]').data("value")
      );
      $rcBundleParentField.val(
        $cartItem.find('[data-name="_rc_bundle_parent"]').data("value")
      );
      $rcBundleVariantField.val(
        $cartItem.find('[data-name="_rc_bundle_variant"]').data("value")
      );
      $rcBundleCollectionIdField.val(
        $cartItem.find('[data-name="_rc_bundle_collection_id"]').data("value")
      );

      // Set Selling Plan
      $selectedSellingPlan.val(
        $sellingPlan.length > 0 ? $sellingPlan.data("selling-plan-name") : ""
      );

      // Reset all qty
      $modal.find(".modal-addons__product-qty-input").val(0);
      $modal.find(".modal-addons__product-qty-input").data("post-type", "add");

      // Loop through and populate the input field
      $contentItems.each(function () {
        const regex = /(\d+x)\s(.+)/;
        const lineItemKey = $(this).data("line-item-key");
        const breakdown = $(this).text().trim().match(regex);

        const productName = breakdown[2]?.trim();
        const productQty = parseInt(breakdown[1].replace(/\D/g, ""));

        const $itemQtyField = $modal.find(
          `[data-product-title="${productName}"] .modal-addons__product-qty-input`
        );

        if ($itemQtyField.length > 0) {
          $itemQtyField.val(productQty);

          $itemQtyField.data("post-type", "update");
          $itemQtyField.data("line-item-key", lineItemKey);

          // Trigger event
          $itemQtyField.trigger("keyup");
        }
      });

      // Debug
      let countAdd = 0;
      let countUpdate = 0;
      $modal.find(".modal-addons__product-qty-input").each(function () {
        if ($(this).data("post-type") === "add") {
          countAdd++;
        } else if ($(this).data("post-type") === "update") {
          countUpdate++;
        }
      });
    };

    const submitAddons = ($el) => {
      const $form = $el;
      const $modal = $el.closest(".modal-addons");
      const $submit = $form.find("[type=submit]");
      const $spinner = $form.find(".loading-overlay__spinner");
      const action = $form.data("action");
      const payload = {
        items: [],
      };

      const toggleFormLoading = (value) => {
        if (value) {
          $submit.addClass("loading");
          $submit.attr("disabled", "disabled");
          $spinner.removeClass("hidden");
        } else {
          $submit.removeClass("loading");
          $submit.removeAttr("disabled");
          $spinner.addClass("hidden");
        }
      };

      // Test subscription Dropdown existance in the page
      // - This is for curated box
      const mainProductSubscription = document.getElementsByClassName(
        "rc-selling-plans-dropdown__select"
      );

      if (mainProductSubscription.length > 0) {
        mainProductSubscriptionSelection = document.getElementsByClassName(
          "rc-selling-plans-dropdown__select"
        )[0].selectedOptions[0].textContent;
      }
      
      // - This is for custom box
      const $dynamicBundleDeliveryFrequency = $('[name=delivery_frequency]:checked');

      if ($dynamicBundleDeliveryFrequency.length > 0) {
        // Hard coded because I'm lazy
        // TODO: Fix this
        mainProductSubscriptionSelection = `Delivery every ${$dynamicBundleDeliveryFrequency.val()} weeks`;
      }

      // In Cart Page, treat it as one-time only
      const isCartPage = window.location.pathname.includes('/cart');
      if (isCartPage) {
        mainProductSubscriptionSelection = null;
      }

      // Construct the payload
      $modal.find("[data-product-item]").each(function () {
        const variantId = $(this).data("variant-id");
        const qty = $(this).find("[name=qty]").val();
        const subscriptionId = $(this).find(`[data-selling-plan-type="${mainProductSubscriptionSelection}"]`)?.data("selling-plan-id") || null;
        
        if (Number(qty) > 0) {
          if (subscriptionId) {
            printLog({
              id: variantId,
              quantity: qty,
              selling_plan: subscriptionId,
            });

            payload.items.push({
              id: variantId,
              quantity: qty,
              selling_plan: subscriptionId,
            });
          } else {
            printLog({
              id: variantId,
              quantity: qty,
            });

            payload.items.push({
              id: variantId,
              quantity: qty,
            });
          }
        }
      });

      if (!payload.items.length) {
        return;
      }

      toggleFormLoading(true);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Error:", error);
          toggleFormLoading(false);
        });
    };

    const toggleErrorNotification = ($parent, show) => {
      const $errorNotification = $parent.find(".notification-box");

      if ($errorNotification.length <= 0) {
        return;
      }

      if (show) {
        $errorNotification.slideDown("fast");
      } else {
        $errorNotification.slideUp("fast");
      }
    };

    const submitBuildABox = async ($el) => {
      const $form = $el;
      const $modal = $el.closest(".modal-addons");
      const $submit = $form.find("[type=submit]");
      const $spinner = $form.find(".loading-overlay__spinner");
      const $errorNotification = $form.find(".notification-box");
      const total = getTotal($modal);
      const minValueInCents = Number($modal.data("min-value")) ?? 0;
      const validationPassed = total * 100 > minValueInCents;
      const selectedSellingPlan = $modal
        .find("[name=selected_selling_plan_name]")
        .val();
      const bundleId = $form.find("[name=_rc_bundle]").val();
      const bundleParentId = $form.find("[name=_rc_bundle_parent]").val();
      const bundleVariantId = $form.find("[name=_rc_bundle_variant]").val();
      const bundleCollectionId = $form
        .find("[name=_rc_bundle_collection_id]")
        .val();
      const action = $form.data("action");
      const addPayload = {
        items: [],
      };

      const updatePayload = {
        updates: {},
      };

      const toggleFormLoading = (value) => {
        if (value) {
          $submit.addClass("loading");
          $submit.attr("disabled", "disabled");
          $spinner.removeClass("hidden");
        } else {
          $submit.removeClass("loading");
          $submit.removeAttr("disabled");
          $spinner.addClass("hidden");
        }
      };

      // Validate
      if (!validateTotal($modal)) {
        return;
      }

      // Construct the payload
      $modal.find("[data-product-item]").each(function () {
        const variantId = $(this).data("variant-id");
        const $qty = $(this).find("[name=qty]");
        const postType = $qty.data("post-type");
        const lineItemKey = $qty.data("line-item-key") || "";
        const qty = $qty.val();
        const $itemSelectedSellingPlan = $(this).find(
          `.modal-addons__product-selling-plan[data-name="${selectedSellingPlan}"]`
        );
        const itemSelectedSellingPlanId =
          $itemSelectedSellingPlan.length > 0
            ? $itemSelectedSellingPlan.data("value")
            : "";

        if (postType === "update") {
          updatePayload.updates[lineItemKey] = Number(qty);
        } else if (postType === "add") {
          if (Number(qty) > 0) {
            const individualPayload = {
              id: variantId,
              quantity: Number(qty),
              properties: {
                _rc_bundle: bundleId,
                _rc_bundle_parent: bundleParentId,
                _rc_bundle_variant: bundleVariantId,
                _rc_bundle_collection_id: bundleCollectionId,
              },
            };

            // TODO: Selling Plan
            printLog({
              selectedSellingPlan,
              itemSelectedSellingPlanId,
            });

            if (selectedSellingPlan && itemSelectedSellingPlanId) {
              individualPayload.selling_plan = itemSelectedSellingPlanId;
            }

            addPayload.items.push(individualPayload);
          }
        }
      });

      toggleFormLoading(true);

      try {
        if (addPayload.items.length) {
          await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(addPayload),
          });
        }

        if (Object.keys(updatePayload.updates).length > 1) {
          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatePayload),
          });
        }

        // Reload
        window.location.reload();
      } catch (error) {
        console.error("Error:", error);
        toggleFormLoading(false);
      }
    };

    await validateRequiredScripts();

    // Hook
    $(".modal-addons").on("submit", "[data-modal-submit]", function (e) {
      e.preventDefault();

      submitAddons($(this));
    });

    $(".modal-addons").on(
      "submit",
      "[data-edit-build-a-box-submit]",
      function (e) {
        e.preventDefault();

        submitBuildABox($(this));
      }
    );

    $(".modal-addons").on(
      "keyup",
      ".modal-addons__product-qty-input",
      function () {
        setQuantity($(this), $(this).val());
      }
    );

    $(".modal-addons").on(
      "click",
      ".modal-addons__product-qty-button__plus",
      function () {
        moveQuantity($(this), 1);
      }
    );

    $(".modal-addons").on(
      "click",
      ".modal-addons__product-qty-button__minus",
      function () {
        moveQuantity($(this), -1);
      }
    );

    $(".modal-addons").on("click", "[data-close-modal]", function (e) {
      e.preventDefault();
      toggleModal($(".modal-addons"), false);
    });

    $(document).on("click", "[data-toggle='addons']", function (e) {
      e.preventDefault();
      toggleModal($(MODAL_ADDONS_IDENTIFIER), true);
    });

    
    $(document).on("click", "[data-toggle='edit-build-a-box']", function () {
      populateBuildABoxItems($(this));
      toggleModal($(MODAL_EDIT_BUILD_A_BOX_IDENTIFIER), true);
    });

    // Start
    setup();

    printLog("modal-addons.js loaded");
  };

  (function () {
    if (document.readyState === 'loading') {
      // DOM is still loading, wait for it
      document.addEventListener('DOMContentLoaded', function () {
        window.modalAddons();
      });
    } else {
      // DOM is already loaded, run immediately
      window.modalAddons();
    }
  })();
}
